import "./PujaInfoView.scss";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import {
  Box,
  Grid,
  Stack,
  Typography,
  Button,
  Dialog,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Divider,
} from "@mui/material";
import TitleTypography from "../../components/typography/TitleTypography";
import ParagraphTypography from "../../components/typography/ParagraphTypography";
import ListItemText from "@mui/material/ListItemText";
import SubtitleTypography from "../../components/typography/SubtitleTypography";
import SubtitleTypographyPrimary from "../../components/typography/SubtitleTypographyPrimary";
import RoundedButton from "../../components/button/RoundedButton";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  calculateDiscountedPrice,
  calculateOverSeasPrice,
  formatNumberWithK,
  getCityStateFromTemple,
  getNearestValidDate,
  getTempleName,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import { useEffect, useState, useMemo } from "react";
import packageImg1 from "../../assets/Package-img1.png";
import packageImg2 from "../../assets/Package-img2.png";
import packageImg3 from "../../assets/Package-img3.png";
import packageImg6 from "../../assets/Package-img6.png";
import packageImg8 from "../../assets/Package-img8.png";
import { ErrorOutlineOutlined as ErrorOutlineOutlinedIcon } from "@mui/icons-material";
import { Close as CloseIcon } from "@mui/icons-material";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import Carousel from "react-multi-carousel";

import {
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  LOCALSTORAGE_KEY,
  DEVOTEE_EXPERIENCE_CAROUSEL,
  PUJALOADIMG,
  orderType,
  pujaSubscriptionSections,
} from "../../utils/Constants";
import dayjs from "dayjs";
import PujaPackageCard from "../../components/card/PujaPackage/PujaPackageCard";
import AlertDialog from "../../components/dialog/AlertDialog";
import moment from "moment";
import { LOCALIZATION } from "../../utils/localization";
import ServiceInfo from "../../components/ServiceInfoDetailsTop/ServiceInfo";
import { pujaSections } from "../../utils/Constants";
import BannerCarouselWithVideo from "../../components/ServiceInfoDetailsTop/BannerCarouselWithVideo";
import ImageView from "../../components/ImageView/ImageView";
import OfferPriceTypography from "../../components/typography/OfferPriceTypography";
import DashboardFeedback from "../../components/card/DashboardFeedback/DashboardFeedback";
import TrustedLogo from "../../components/trustedLogo/TrustedLogo";
import { PUJA_SCROLL_RESPONSIVE } from "../../utils/cssConstants";
import Infographics from "../../components/Infographics/Infographics";
import ShowMoreShowLess from "../../components/ShowMoreShowLess/ShowMoreShowLess";
import {
  infographicDesktop,
  infographicMobile,
} from "../../utils/imageConstants";
import VideoCard from "../../components/card/videoCard/VideoCard";
import PujaPlanSelector from "../../components/pujaPlanSelector/PujaPlanSelector";
import CustomDay from "../../components/customDay/CustomDay";
import SubscriptionSwitch from "../../components/subscriptionSwitch/SubscriptionSwitch";
import { getFirstAvailableBookingDate } from "../../utils/dateUtilFunctions";
import SubSectionNav from "../../components/subNavigation/SubSectionNav";
import useStickySwitcher from "../../hooks/useStickySwitcher";

function PujaView(props: any) {
  const { t } = useTranslation();
  const {
    selectedTempleDetails,
    pujaPriceInfo,
    avialableCouponCode,
    pujaDetails,
    setPopupPujaAlreadyAdded,
    preprocessingAndProceedToAddmemberScreen,
    isSingleDatePuja,
    setIsDateTimePicker,
    isSingleDatePujaEnabled,
    isDateTimePicker,
    shouldDisableDate,
    setPujaDateAndTime,
    pujaDateAndTime,
    popupPujaAlreadyAdded,
    overSeasRate,
    currencySymbols,
    isOverseas,
    isCountryDisabledForBooking,
    defaultCalendardate,
    setDefaultCalendardate,
    userReview,
    itemAddLimitPopUp,
    setItemAddLimitPopUp,
    pujaPreviewVideos,
    allowSubscription,
    handleSubscriotionSwitch,
    handleSelectPujaSubscription,
    pujaSubscriptionPlans,
    currentSubscriptionPlan,
    isSubscriptionPresent,
    originalPrice,
  } = props;

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeName = getTempleName(selectedTempleDetails, savedLanguage);
  const personalInfo = selectedTempleDetails?.personalInfo;
  const templeAddress = getCityStateFromTemple(personalInfo);

  // const templeAddress =
  //   (personalInfo?.address?.street ||
  //     personalInfo?.address?.city ||
  //     personalInfo?.address?.area) +
  //   " , " +
  //   personalInfo?.address?.state;

  const getImageForBenefitsDataByBenefitId = (benefitId: string) => {
    const benefitList = props.benefitsList;
    const benefitFilterData = benefitList.filter(function (item: any) {
      return item.benefitId === benefitId;
    });
    if (benefitList.length > 0) {
      return benefitFilterData[0];
    } else {
      return null;
    }
  };
  const packageSelected = props.packageSelected;

  const [
    openAlertDialogForBookingNotAllowed,
    setOpenAlertDialogForBookingNotAllowed,
  ] = useState<any>(false);
  const actualPujaPriceAggregated = pujaPriceInfo?.finalPrice;

  const couponCodeText = avialableCouponCode?.couponCode;

  const [urlToShare, setUrlToShare] = useState<string>("");
  const [activeVideoUrl, setActiveVideoUrl] = useState<number | null>(null);
  const [activeVideoId, setActiveVideoId] = useState<number | null>(null);

  // CUSTOM HOOKs
  const isAboveFooter = useStickySwitcher(".footerArea", "50px");

  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?pujaNameKey=${pujaDetails?.pujaNameKey}&templeNameKey=${selectedTempleDetails?.nameKey}`
    );

    // }
  }, [selectedTempleDetails, pujaDetails]);

  const getActivePujaSubscriptionSections = () => {
    return pujaSubscriptionSections.filter(() => {
      return (
        Array?.isArray(pujaSubscriptionPlans) &&
        pujaSubscriptionPlans?.length > 0
      );
    });
  };

  const subHeader = useMemo(() => {
    let updatedHeader = [...pujaSections];
    if (allowSubscription) {
      const subscriptionSections = getActivePujaSubscriptionSections();

      if (subscriptionSections.length > 0) {
        updatedHeader = [...subscriptionSections, ...updatedHeader];
      }
    }

    const hasPujaPreviewVideos =
      Array.isArray(pujaPreviewVideos) && pujaPreviewVideos?.length > 0;

    if (hasPujaPreviewVideos) {
      if (!updatedHeader.some((item) => item.id === "puja-video-preview")) {
        const faqIndex = updatedHeader.findIndex((item) => item.id === "FAQ");
        const newSection = {
          id: "puja-video-preview",
          label: "The_Temple_Dekho_Promise",
        };
        if (faqIndex !== -1) {
          updatedHeader.splice(faqIndex, 0, newSection);
        } else {
          updatedHeader.push(newSection);
        }
      }
    } else {
      updatedHeader = updatedHeader.filter(
        (item) => item.id !== "puja-video-preview"
      );
    }
    return updatedHeader;
  }, [
    pujaDetails?.id,
    pujaPreviewVideos,
    allowSubscription,
    pujaSubscriptionPlans?.length,
  ]);

  const sortPackageData = (multiplePujaDetails: any) => {
    let multiplePuja = [...multiplePujaDetails];
    let data = multiplePuja.sort((a: any, b: any) =>
      Number(a.maxMemberAllowed) > Number(b.maxMemberAllowed) ? 1 : -1
    );

    return data;
  };

  const pujaBgImage =
    pujaDetails && pujaDetails.pujaBg && pujaDetails.pujaBg.uri
      ? pujaDetails.pujaBg.uri
      : PUJALOADIMG;
  let pujaPackages =
    pujaDetails && pujaDetails.multiplePujaDetails
      ? sortPackageData(pujaDetails.multiplePujaDetails)
      : [];

  const bookedSingleDatePuja = () => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
      return;
    }
    // if (cartInfo && cartInfo.length > 0) {
    //   setPopupPujaAlreadyAdded(true);
    // } else {
    //   preprocessingAndProceedToAddmemberScreen();
    // }
    preprocessingAndProceedToAddmemberScreen();
  };

  const handleSetIsDateTimePicker = (isOpen: boolean) => {
    if (isCountryDisabledForBooking) {
      setOpenAlertDialogForBookingNotAllowed(true);
    } else {
      setIsDateTimePicker(isOpen);
    }
  };

  const handleCloseAlertDialogForBookingNotAllowed = () => {
    setOpenAlertDialogForBookingNotAllowed(false);
  };

  const getDevoteeImage = (index: any) => {
    switch (index) {
      case "1":
        return packageImg1;
      case "2":
        return packageImg2;
      case "4":
        return packageImg3;
      case "6":
        return packageImg6;
      case "8":
        return packageImg8;
      default:
        return packageImg8;
    }
  };

  // END

  const minDate = dayjs().add(2, "day");
  const [expanded, setExpanded] = useState<string | false>("panel1");
  const handleChange1 =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const [pujaEndTime, setPujaEndTime] = useState<any>(null);

  
  useEffect(() => {
    const firstDate = getFirstAvailableBookingDate(pujaDetails?.restrictionDate ?? []);
    if (firstDate) {
      setPujaDateAndTime((prev: any) => ({
        ...prev,
        pujaDate: dayjs(firstDate),
      }));
      setDefaultCalendardate(firstDate);
    }
  }, [pujaDetails?.id]);
  
  useEffect(() => {
    const newDateSubtract = moment(
      getNearestValidDate(pujaDetails?.restrictionDate)
    )
      .clone()
      .subtract(3, "days")
      .toDate(); // Convert back to Date object
    setPujaEndTime(newDateSubtract);
  }, [pujaDetails]);

  const isPujaBookingClosed = () => {
    return !!(
      selectedTempleDetails?.isClosed ||
      selectedTempleDetails?.isClosedBooking ||
      pujaDetails?.isPujaDisable
    );
  };


  const pujaImageArr =
    pujaDetails?.multiPujaImg && pujaDetails?.multiPujaImg.length
      ? pujaDetails.multiPujaImg.map((_itm: any) => {
          if (_itm?.pictureUrl) {
            return { pictureUrl: _itm.pictureUrl };
          } else if (_itm?.videoUrl) {
            return { videoUrl: _itm.videoUrl };
          } else {
            return { pictureUrl: PUJALOADIMG };
          }
        })
      : [{ pictureUrl: pujaBgImage }];

  const isReviewSingle = userReview?.length === 1 ? true : false;

  const finalPujaPriceText = `${currencySymbols}${
    calculateOverSeasPrice(actualPujaPriceAggregated, overSeasRate) || " "
  }`;

  const bookedCountPuja =
    pujaDetails?.acctualPrice && pujaDetails?.acctualPrice > 0
      ? formatNumberWithK(pujaDetails.acctualPrice * 2.5)
      : formatNumberWithK(13 * 145);

  const pujaBookedText = t(LOCALIZATION.devotees_booked_puja_from_this_temple);

  const isDoubleVideoItem = pujaPreviewVideos?.length <= 2;
  const handleAfterChange = (currentIndex: number) => {
    setActiveVideoUrl(currentIndex);
  };
  const handleAfterChangeReview = (currentReviewIndex: number) => {
    setActiveVideoId(currentReviewIndex);
  };
  return (
    <Box className="pageContainer pujaPage">
      <Box className="pujaBlock">
        <Grid container spacing={1}>
          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="pagehdLeftBlock"
          ></Grid>
          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="pujainfoCenterBlock">
              <Box className="pujaCard" data-scroll-id={`${pujaDetails?.id}`}>
                <Grid className="pujaCardBlock" container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <BannerCarouselWithVideo imageArray={pujaImageArr} />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={6}>
                    <ServiceInfo
                      pujaName={pujaDetails?.pujaName}
                      templeName={templeName}
                      templeAddress={templeAddress}
                      finalPujaPriceText={finalPujaPriceText}
                      bookedCount={bookedCountPuja}
                      bookedText={pujaBookedText}
                      itemOrderType={orderType?.puja}
                      urlToShare={urlToShare}
                      pujaEndTime={pujaEndTime}
                      tithiName={pujaDetails?.tithiName}
                      couponCodeText={couponCodeText}
                      offerActualPrice={pujaPriceInfo?.offerActualPrice}
                      overSeasRate={overSeasRate}
                      currencySymbols={currencySymbols}
                      isOverseas={isOverseas}
                    />
                  </Grid>
                </Grid>

                {isPujaBookingClosed() && (
                  <ListItemText sx={{ color: "red" }}>
                    {t(LOCALIZATION.Pooja_Booking_Closed)}
                  </ListItemText>
                )}

                <Box
                  className="continueBtn desktopOnly sticky-button"
                  sx={{ position: `${isAboveFooter ? "absolute" : "fixed"}` }}
                >
                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box
                      display="flex"
                      gap={2}
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Typography className="pujaPriceText">
                        {`${currencySymbols}${
                          calculateOverSeasPrice(
                            actualPujaPriceAggregated,
                            overSeasRate
                          ) || " "
                        }`}
                      </Typography>
                      {pujaPriceInfo?.offerActualPrice > 0 && (
                        <OfferPriceTypography
                          currencySymbol={currencySymbols ?? "₹"}
                          amount={
                            isOverseas
                              ? truncateToTwoDecimals(
                                  pujaPriceInfo?.offerActualPrice * overSeasRate
                                )
                              : pujaPriceInfo?.offerActualPrice
                          }
                        />
                      )}
                    </Box>
                    <Button
                      className="desktopContinueBtn"
                      variant="contained"
                      onClick={() => {
                        if (allowSubscription) {
                          preprocessingAndProceedToAddmemberScreen();
                          return;
                        }
                        if (isSingleDatePuja) {
                          bookedSingleDatePuja();
                        } else {
                          handleSetIsDateTimePicker(true);
                        }
                      }}
                      disabled={
                        (!allowSubscription && isPujaBookingClosed()) ||
                        (!allowSubscription &&
                          isSingleDatePuja &&
                          !isSingleDatePujaEnabled)
                      }
                    >
                      {(!allowSubscription && isPujaBookingClosed()) ||
                      (!allowSubscription &&
                        isSingleDatePuja &&
                        !isSingleDatePujaEnabled)
                        ? t(LOCALIZATION.Pooja_Booking_Closed)
                        : t(LOCALIZATION.Continue_to_Book)}
                    </Button>
                  </Stack>
                </Box>
              </Box>

              <Box className="pujaInfoContainer">
                <SubSectionNav
                  sections={subHeader}
                />

                {isSubscriptionPresent && (
                  <Box className="chadhavaSubscriptionAreaSwitch" data-scroll-id={"pujaSubscriptionSwitch"}>
                    <SubscriptionSwitch
                      buttonTextLeft={t(LOCALIZATION?.Single_Time_Puja)}
                      buttonTextRight={t(LOCALIZATION?.Puja_Subscription)}
                      badgeText={t(LOCALIZATION?.Save_More)}
                      showSubscription={allowSubscription}
                      onToggle={handleSubscriotionSwitch}
                    />
                  </Box>
                )}

                {allowSubscription && (
                  <Box
                    className="chadhavaPlanArea animate-enter"
                    key="subscription-view"
                  >
                    <Typography
                      className="planAreaTitle"
                      id="Select_your_Puja_plan"
                    >
                      {t(LOCALIZATION?.Select_your_Puja_plan)}
                    </Typography>

                    {
                      <Box className="planList" data-scroll-id={`${pujaSubscriptionPlans?.subscriptionId}`} sx={{ marginTop: "0.25rem" }}>
                        {pujaSubscriptionPlans?.map((plan: any) => (
                          <PujaPlanSelector
                            key={plan?.subscriptionId}
                            isPlanSelected={
                              currentSubscriptionPlan?.subscriptionId ===
                              plan?.subscriptionId
                            }
                            title={plan?.title}
                            description={plan?.description}
                            price={
                              calculateDiscountedPrice(
                                originalPrice?.finalPrice,
                                Number(plan?.fixDiscount)
                              ) * overSeasRate
                            }
                            frequency={Number(plan?.frequency ?? 0) ?? 0}
                            discount={Number(plan?.fixDiscount ?? 0) ?? 0}
                            onChange={() => {
                              handleSelectPujaSubscription(plan);
                            }}
                            cuttedPrice={truncateToTwoDecimals(
                              originalPrice?.finalPrice *
                                plan?.frequency *
                                overSeasRate
                            )}
                            currency={currencySymbols}
                          />
                        ))}
                      </Box>
                    }
                  </Box>
                )}
                {allowSubscription && pujaSubscriptionPlans?.length > 0 && (
                  <Divider
                    sx={{
                      borderBottom: "3px solid #fff",
                      paddingTop: "0.8rem",
                    }}
                  />
                )}

                {packageSelected ? (
                  <Box
                    className="SelectPackage animate-enter"
                    id="puja-package"
                    key={`package-view ${allowSubscription ? "subs" : ""}`}
                    data-scroll-id={`${packageSelected?.packageId}`}              
                  >
                    <SubtitleTypographyPrimary
                      title={t("Select_Puja_Package")}
                    ></SubtitleTypographyPrimary>
                    <Box className="packageItem">
                      <Carousel
                        responsive={PUJA_SCROLL_RESPONSIVE}
                        swipeable={true}
                        draggable={true}
                        showDots={false}
                        keyBoardControl={true}
                        removeArrowOnDeviceType={
                          CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                        }
                        className="pujaPackCarousel"
                      >
                        {pujaPackages.map((item: any) => {
                          let activeFlg = "inactive";
                          if (
                            packageSelected &&
                            packageSelected?.packageId === item?.packageId
                          ) {
                            activeFlg = "active";
                          }
                          return (
                            <PujaPackageCard
                              key={item?.packageId}
                              setPackageSelected={props.setPackageSelected}
                              getDevoteeImage={getDevoteeImage}
                              activeFlg={activeFlg}
                              packageDetails={item}
                              selectedTempleDetails={selectedTempleDetails}
                              pujaDetails={pujaDetails}
                              overSeasRate={overSeasRate}
                              currencySymbols={currencySymbols}
                              isOverseas={isOverseas}
                              isCountryDisabledForBooking={
                                isCountryDisabledForBooking
                              }
                            />
                          );
                        })}
                      </Carousel>
                    </Box>
                  </Box>
                ) : null}

                {pujaDetails?.description && (
                  <Box className="overViewText" id="puja-overview" data-scroll-id={`${pujaDetails?.id ?? pujaDetails?.description}`}>
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.Puja_Overview)}
                    />
                    <ParagraphTypography
                      title={
                        <ShowMoreShowLess
                          text={pujaDetails?.description || ""}
                          mode="line"
                          lines={2}
                        />
                      }
                    />
                  </Box>
                )}

                <Box className="pujaBenefits" id="puja-benefits" data-scroll-id={`${pujaDetails?.benefitList}`}>
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Benefits_of_this_Puja)}
                  ></SubtitleTypographyPrimary>
                  {pujaDetails &&
                    pujaDetails.benefitList &&
                    pujaDetails.benefitList.map((item: any) => {
                      let updatedBenefitsData = item;
                      const benefitDetais = getImageForBenefitsDataByBenefitId(
                        item.benefitId
                      );

                      if (benefitDetais) {
                        updatedBenefitsData = benefitDetais;
                      }
                      return (
                        <Box
                          className="benefitsCard"
                          key={updatedBenefitsData?.name}
                        >
                          <SubtitleTypography
                            title={`${updatedBenefitsData?.name}`}
                          ></SubtitleTypography>
                          <Box className="benefitCardImg">
                            <ImageView
                              src={`${updatedBenefitsData?.url}`}
                              alt="Benefit Image"
                            />
                          </Box>
                          <ParagraphTypography
                            title={`${updatedBenefitsData?.description}`}
                          ></ParagraphTypography>
                        </Box>
                      );
                    })}
                </Box>

                <Box className="pujaProccessSteps" id="quick-steps" data-scroll-id={"pujaInfographic"}>
                  <Infographics
                    infographicDesktop={infographicDesktop}
                    infographicMobile={infographicMobile}
                  />
                </Box>
                {/* Devotee Experience */}
                {userReview?.length ? (
                  <Box
                    className="testimonial carouselArrowColor"
                    id="devotee-experience"
                    data-scroll-id={"devoteeExperiencePuja"}
                  >
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.Devotee_Experience)}
                    ></SubtitleTypographyPrimary>
                    <Box mt={2}>
                      <Carousel
                        responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                        swipeable={true}
                        draggable={true}
                        showDots={true}
                        keyBoardControl={true}
                        removeArrowOnDeviceType={
                          CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                        }
                        className={`testimonialCarousel ${
                          isReviewSingle ? "singleItem" : ""
                        }`}
                        afterChange={handleAfterChangeReview}
                        pauseOnHover={false}
                      >
                        {userReview?.length > 0 &&
                          userReview?.map((_item: any) => (
                            <DashboardFeedback
                              key={_item?.id}
                              feedbackData={_item}
                              pujaDetails={pujaDetails}
                              selectedTempleDetails={selectedTempleDetails}
                              className="compactFeedbackCard"
                              activeVideoId={activeVideoId}
                              setActiveVideoId={setActiveVideoId}
                            />
                          ))}
                      </Carousel>
                    </Box>
                  </Box>
                ) : null}

                {/* "Puja_Contribution_Details" */}
                <Box
                  className="PujaContribution"
                  id="Puja-Contribution-Details"
                  data-scroll-id={"PujaPage-Contribution-Details"}
                >
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Puja_Contribution_Details)}
                  />
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {t(
                      LOCALIZATION.Your_gracious_contribution_for_this_sacred_puja_offering
                    )}
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {t(
                      LOCALIZATION.We_express_our_heartfelt_gratitude_for_your_participation
                    )}
                  </Typography>
                </Box>

                {/* Trust Build VideoUrl Preview */}
                {pujaPreviewVideos.length > 0 && (
                  <Box
                    className="pujaVideoPreview carouselArrowColor"
                    id="puja-video-preview"
                    data-scroll-id={"temple-dekho-trust-video"}
                  >
                    <SubtitleTypographyPrimary
                      title={t(LOCALIZATION.The_Temple_Dekho_Promise)}
                    />
                    <Typography variant="body1" mt={1}>
                      {t(LOCALIZATION.Promise_Video_Description)}
                    </Typography>

                    <Box mt={3}>
                      {Array.isArray(pujaPreviewVideos) &&
                        pujaPreviewVideos.length > 0 && (
                          <Carousel
                            responsive={DEVOTEE_EXPERIENCE_CAROUSEL}
                            swipeable
                            draggable
                            showDots
                            keyBoardControl
                            autoPlaySpeed={4000}
                            infinite
                            removeArrowOnDeviceType={
                              CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                            }
                            className={`pujaVideoCarousel ${
                              isDoubleVideoItem ? "singleItem" : ""
                            }`}
                            afterChange={handleAfterChange}
                            pauseOnHover={false}
                          >
                            {pujaPreviewVideos?.map(
                              (video: any, index: number) => (
                                <VideoCard
                                  key={video?.videoUrl}
                                  videoUrl={video?.videoUrl}
                                  showVideoDescription={
                                    video?.showVideoDescription ?? ""
                                  }
                                  isPlaying={activeVideoUrl === index}
                                  onClickPlay={(isPlay: boolean) => {
                                    if (isPlay) {
                                      setActiveVideoUrl(index);
                                    } else {
                                      setActiveVideoUrl(null);
                                    }
                                  }}
                                />
                              )
                            )}
                          </Carousel>
                        )}
                    </Box>
                  </Box>
                )}

                {/* FAQ */}
                <Box className="chadhavaFaq" id="faq" data-scroll-id={"puja-details-faq"}>
                  <SubtitleTypographyPrimary
                    title={t(LOCALIZATION.Frequently_Asked_Questions)}
                  ></SubtitleTypographyPrimary>
                  <Box className="chadhavaFaqList">
                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel1"}
                      onChange={handleChange1("panel1")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel1" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel1"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel1-content"
                        id="panel1-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.What_is_Temple_Dekho_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(LOCALIZATION.What_is_Temple_Dekho_FAQ_Answer)}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel2"}
                      onChange={handleChange1("panel2")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel2" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel2"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel2-content"
                        id="panel2-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.What_makes_your_virtual_puja_services_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.What_makes_your_virtual_puja_services_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel3"}
                      onChange={handleChange1("panel3")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel3" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel3"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel3-content"
                        id="panel3-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_you_prioritize_the_security_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.How_do_you_prioritize_the_security_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel4"}
                      onChange={handleChange1("panel4")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel4" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel4"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel4-content"
                        id="panel4-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Who_is_designated_to_perform_my_Puja_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Who_is_designated_to_perform_my_Puja_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel5"}
                      onChange={handleChange1("panel5")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel5" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel5"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel5-content"
                        id="panel5-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Can_I_participate_in_a_Puja_if_I_don_know_my_Gotram_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Can_I_participate_in_a_Puja_if_I_don_know_my_Gotram_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel6"}
                      onChange={handleChange1("panel6")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel6" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel6"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel6-content"
                        id="panel6-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_I_get_evidence_of_my_Puja_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.How_do_I_get_evidence_of_my_Puja_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel7"}
                      onChange={handleChange1("panel7")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel7" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel7"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel7-content"
                        id="panel7-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(
                          LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ
                        )}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(
                          LOCALIZATION.Who_should_I_reach_out_to_for_more_details_FAQ_Answer
                        )}
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      className="accordionInfo"
                      expanded={expanded === "panel8"}
                      onChange={handleChange1("panel8")}
                      sx={{
                        "&.Mui-expanded::before": {
                          opacity: 1,
                        },
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            sx={{
                              color: expanded === "panel8" ? "#d56939" : "#000",
                              transform:
                                expanded === "panel8"
                                  ? "rotate(180deg)"
                                  : "rotate(270deg)",
                              transition: "transform 0.3s ease",
                            }}
                          />
                        }
                        aria-controls="panel8-content"
                        id="panel8-header"
                        sx={{
                          p: 0,
                          fontWeight: "600",
                        }}
                      >
                        {t(LOCALIZATION.How_do_I_receive_the_prasad_FAQ)}
                      </AccordionSummary>
                      <AccordionDetails sx={{ p: 0, lineHeight: "1.5" }}>
                        {t(LOCALIZATION.How_do_I_receive_the_prasad_FAQ_Answer)}
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                </Box>
              </Box>
              <TrustedLogo />
              <Box className="blessContinue" data-scroll-id={"bless-yourself-certification"}>
                {actualPujaPriceAggregated > 0 && (
                  <Box className="continueCart" data-scroll-id={"continue-cart-puja"}>
                    <Box className="continueCenterBlock">
                      <Box
                        display="flex"
                        gap={1}
                        justifyContent="center"
                        alignItems="center"
                        className="continueLt"
                      >
                        {`${currencySymbols}${calculateOverSeasPrice(
                          actualPujaPriceAggregated,
                          overSeasRate
                        )}`}
                        /-
                        {pujaPriceInfo?.offerActualPrice > 0 && (
                          <OfferPriceTypography
                            currencySymbol={currencySymbols ?? "₹"}
                            amount={
                              isOverseas
                                ? truncateToTwoDecimals(
                                    pujaPriceInfo?.offerActualPrice *
                                      overSeasRate
                                  )
                                : pujaPriceInfo?.offerActualPrice
                            }
                          />
                        )}
                      </Box>
                      <Box className="continueRt" data-scroll-id={"continue-button"}>
                        <Button
                          type="button"
                          className="continueBtn"
                          disabled={
                            (!allowSubscription && isPujaBookingClosed()) ||
                            (!allowSubscription &&
                              isSingleDatePuja &&
                              !isSingleDatePujaEnabled)
                          }
                          onClick={() => {
                            if (allowSubscription) {
                              preprocessingAndProceedToAddmemberScreen();
                              return;
                            }
                            if (isSingleDatePuja) {
                              bookedSingleDatePuja();
                            } else {
                              handleSetIsDateTimePicker(true);
                            }
                          }}
                        >
                          {(!allowSubscription && isPujaBookingClosed()) ||
                          (!allowSubscription &&
                            isSingleDatePuja &&
                            !isSingleDatePujaEnabled)
                            ? "Booking Closed"
                            : t(LOCALIZATION.Continue)}
                        </Button>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={2} lg={2} xl={2} className="pagehdRightBlock">
            {/* <RightBlockCard /> */}
          </Grid>
        </Grid>
        <Dialog
          className="dateTimingSelection"
          onClose={() => handleSetIsDateTimePicker(false)}
          open={isDateTimePicker}
        >
          <Box className="dateTimePopup">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="calendarTopInfo"
            >
              <TitleTypography
                title={t(LOCALIZATION.Select_Date)}
              ></TitleTypography>
              <IconButton
                aria-label="close"
                onClick={() => handleSetIsDateTimePicker(false)}
                className="topCloseIconBtn"
                sx={{
                  position: "absolute",
                  right: 14,
                  top: 14,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Stack>

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="flex-start"
              className="pujaReminderSec"
            >
              <ErrorOutlineOutlinedIcon />
              <Typography className="pujaReminderText">
                {t(
                  LOCALIZATION.The_booking_for_the_puja_will_be_closed_two_days_before_the_scheduled_date
                )}{" "}
              </Typography>
            </Stack>

            <Box className="calendarInfo">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  showDaysOutsideCurrentMonth={true}
                  shouldDisableDate={shouldDisableDate}
                  disablePast={false}
                  minDate={minDate}
                  referenceDate={defaultCalendardate}
                  disableHighlightToday={true}
                  slots={{ day: CustomDay }}
                  slotProps={{
                    day: {
                      shouldDisableDate: shouldDisableDate,
                    } as any,
                  }}
                  value={pujaDateAndTime?.pujaDate || null}
                  onChange={(value: any) => {
                    setPujaDateAndTime({
                      ...pujaDateAndTime,
                      pujaDate: value,
                    });
                  }}
                />
              </LocalizationProvider>
            </Box>
            <Box className="btnContinue">
              <RoundedButton
                title={t(LOCALIZATION.Continue)}
                disabled={
                  pujaDateAndTime && pujaDateAndTime.pujaDate ? false : true
                }
                onClick={() => {
                  handleSetIsDateTimePicker(false);
                  preprocessingAndProceedToAddmemberScreen();
                  // if (cartInfo && cartInfo.length > 0) {
                  //   setPopupPujaAlreadyAdded(true);
                  // } else {
                  //   preprocessingAndProceedToAddmemberScreen();
                  // }
                }}
              ></RoundedButton>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          onClose={() => setPopupPujaAlreadyAdded(false)}
          open={popupPujaAlreadyAdded}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>
              {t(LOCALIZATION.A_puja_already_added_in_your_cart)}
            </Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setPopupPujaAlreadyAdded(false)}>
                {t(LOCALIZATION.No)}
              </Button>
              <Button
                onClick={() => preprocessingAndProceedToAddmemberScreen()}
              >
                {t(LOCALIZATION.Yes)}
              </Button>
            </Box>
          </Box>
        </Dialog>

        <Dialog
          onClose={() => setItemAddLimitPopUp(false)}
          open={itemAddLimitPopUp}
        >
          <Box style={{ padding: "1em" }}>
            <Typography>{t(LOCALIZATION.Cart_Max_Limit_Message)}</Typography>
            <Box sx={{ textAlign: "end" }}>
              <Button onClick={() => setItemAddLimitPopUp(false)}>
                {t(LOCALIZATION.OK)}
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      {/* <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Text copied to clipboard"
      /> */}
      <AlertDialog
        open={openAlertDialogForBookingNotAllowed}
        onClose={handleCloseAlertDialogForBookingNotAllowed}
        message={t(
          LOCALIZATION.Prasad_Bookings_are_not_permitted_in_your_country
        )}
      />
    </Box>
  );
}

export default PujaView;
